__turbopack_context__.v({
  "body": "-4HhMa_body",
  "chip": "-4HhMa_chip",
  "chipOn": "-4HhMa_chipOn",
  "chips": "-4HhMa_chips",
  "closeButton": "-4HhMa_closeButton",
  "empty": "-4HhMa_empty",
  "emptyIcon": "-4HhMa_emptyIcon",
  "formCard": "-4HhMa_formCard",
  "header": "-4HhMa_header",
  "headerActions": "-4HhMa_headerActions",
  "hint": "-4HhMa_hint",
  "kbd": "-4HhMa_kbd",
  "list": "-4HhMa_list",
  "modalBody": "-4HhMa_modalBody",
  "modalFooter": "-4HhMa_modalFooter",
  "modalHeader": "-4HhMa_modalHeader",
  "modalTitle": "-4HhMa_modalTitle",
  "modalTitleBlock": "-4HhMa_modalTitleBlock",
  "notificationRow": "-4HhMa_notificationRow",
  "panel": "-4HhMa_panel",
  "read": "-4HhMa_read",
  "row": "-4HhMa_row",
  "rowContent": "-4HhMa_rowContent",
  "rowLink": "-4HhMa_rowLink",
  "severityAvatar": "-4HhMa_severityAvatar",
  "skeletonRow": "-4HhMa_skeletonRow",
  "textButton": "-4HhMa_textButton",
  "titleLine": "-4HhMa_titleLine",
  "toolbar": "-4HhMa_toolbar",
  "unread": "-4HhMa_unread",
});
